// extracted by mini-css-extract-plugin
module.exports = {"container":"helpSection_container__2RZt0","text":"helpSection_text__1Q5SK","btnContainer":"helpSection_btnContainer__2sQKM","button":"helpSection_button__17Xcz"};
    if(module.hot) {
      // 1790670314722
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  